import axios from "axios";
import constants from "../constants";
import generateCorrelationId from "./generateCorrelationId";
import getCurrentDateTime from "./getCurrentDateTime";

const apiKey = process.env.REACT_APP_X_API_KEY;
export default function axiosPost({
  url,
  data,
  headers,
  callback,
  errorCallback,
}) {
  axios
    .post(url, data, {
      headers: {
        ...headers,
        "Content-Type": "Application/json",
        "X-Transmission-Date-Time": getCurrentDateTime(),
        "X-Correlation-Id": generateCorrelationId(),
        "X-Api-Key": apiKey,
      },
    })
    .then((res) => {
      if (res.data.statusCode === constants.HTTP_STATUS_SUCCESS) {
        callback(res.data);
      } else {
        errorCallback(res.data);
      }
    })
    .catch((err) => {
      errorCallback(err);
    });
}
